import React, { useCallback, useRef, useState, useEffect } from "react";
import lockIcon from "../assets/icons/lock.png";     // use your actual image path
import unlockIcon from "../assets/icons/unlocked.png"; // use your actual image path

const SwipeButton = ({ label, onSwipe, error, disabled, successLabel = "Unlocked" }) => {
  const trackRef = useRef(null);
  const knobRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [offsetX, setOffsetX] = useState(0);
  const [unlocked, setUnlocked] = useState(false);
  const [rotation, setRotation] = useState(0); // degree of rotation


  const getTouchX = (e) => e.touches?.[0]?.clientX || 0;

  const handleMove = useCallback((clientX) => {
    if (disabled) {
      return;
    }

    const track = trackRef.current;
    const knob = knobRef.current;
    if (!track || !knob) {
      return;
    }

    const rect = track.getBoundingClientRect();
    let newX = clientX - rect.left - knob.offsetWidth / 2;

    const maxX = track.offsetWidth - knob.offsetWidth;
    if (newX < 0) newX = 0;
    if (newX > maxX) newX = maxX;

    setOffsetX(newX);

    // Rotation: 0 to 360 degrees
    const progress = maxX > 0 ? newX / maxX : 0;
    const angle = progress * 360;
    setRotation(angle);
  }, [disabled]);


  const handleEnd = useCallback(() => {
    if (!dragging || !trackRef.current || !knobRef.current) return;
    const maxX = trackRef.current.offsetWidth - knobRef.current.offsetWidth;

    if (offsetX >= maxX - 10) {
      setUnlocked(true);
      onSwipe();
      setTimeout(() => {
        setOffsetX(0);
        setRotation(0);
        setUnlocked(false);
      }, 2000);
    } else {
      setOffsetX(0);
      setRotation(0);
    }

    setDragging(false);
  }, [dragging, offsetX, onSwipe]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (dragging) handleMove(e.clientX);
    };
    const handleTouchMove = (e) => {
      if (dragging) handleMove(getTouchX(e));
    };
    const handleMouseUp = () => handleEnd();
    const handleTouchEnd = () => handleEnd();

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [dragging, handleEnd, handleMove]);

  return (
    <div className={`swipe-track ${disabled ? "disabled" : ""} ${(unlocked && !error) ? "bg-green-500" : ""}`} ref={trackRef} aria-disabled={disabled ? "true" : undefined}>
      <span className="swipe-label">{(unlocked && !error) ? successLabel : label}</span>
      <div
        ref={knobRef}
        className="swipe-knob"
        style={{ transform: `translateX(${offsetX}px)` }}
        onMouseDown={() => !disabled && setDragging(true)}
        onTouchStart={() => !disabled && setDragging(true)}
      >
        <img
          src={(unlocked && !error) ? unlockIcon : lockIcon}
          alt="lock"
          className="lock-icon"
          style={{ transform: `rotate(${rotation}deg)`, transition: dragging ? "none" : "transform 0.3s" }}

        />
      </div>
    </div>
  );
};

export default SwipeButton;
